const attendanceMap: Record<string, string> = {
  recommended: 'recommended',
  regular: 'optional',
};

const getAttendance =
  (result: 'label' | 'value') =>
  (val = '') => {
    const searchVal = val.toLowerCase();

    const matchedAttendance = Object.entries(attendanceMap).find(entry =>
      entry.includes(searchVal),
    );

    return matchedAttendance?.[result === 'label' ? 0 : 1] || val;
  };
export const getAttendanceLabel = getAttendance('label');
export const getAttendanceValue = getAttendance('value');
